module.exports = function (fulfilmentType) {
   return {
       event: 'BWSAUchangeFulfilmentMethod',
       eventContext: {
           area: 'Checkout - Step 1',
           newFullfilmentType: fulfilmentType
       }
   };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/delivery/atmmapper/change-fulfilment-method-mapper.js
 **/